<template>
<div class="nj-search-box" @click="stopPropagation($event)">
    <div class="nj-label">{{ label }}</div>
    <div class="nj-search-box-container">
        <div class="nj-search-box-elements">
            <input type="text" class="nj-search-box--text" v-model="text" @keyup.enter="search()" @keyup.esc="hide()" :disabled="disabled" placeholder="buscar..." @click="show()"
                ref="nj-search-box--text">
            <Button title="Buscar" icon="search" @click="search()"></Button>
        </div>
        <div class="nj-search-box--items" @keydown="navigate($event)">
            <div class="nj-search-box--item" v-for="item in items" :key="item[itemKey]" @keyup.enter="selectItem(item)" @click="selectItem(item)" tabindex="0">
                <template v-if="labelFunction != null">
                    {{ labelFunction(item) }}
                </template>
                <template v-else>
                    <slot :item="item"></slot>
                </template>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Button from "./Button.vue"
export default {
    name: "SearchBox",
    props: {
        value: {
            default: null
        },
        label: {
            type: String,
            default: "Label"
        },
        itemKey: {
            type: String,
            required: true
        },
        itemValue: {
            type: String,
            default: null
        },
        source: {
            type: Array,
            default: []
        },
        labelFunction: {
            type: Function,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        searchFunction: {
            type: Function,
            required: true
        },
    },
    components: {
        Button,
    },
    computed: {

    },
    watch: {
        source(newSource) {
            if (newSource != null) {
                this.showItems()
            }
        },
    },
    data() {
        return {
            text: null,
            items: [],
            width: "100%",
        }
    },
    methods: {
        search() {
            this.searchFunction(this.text)
        },
        show() {
            this.items = this.source
        },
        hide() {
            this.items = []
        },
        selectItem(item) {
            if (this.itemValue != null) {
                this.$emit("input", item[this.itemValue])
            }
            this.$emit("selectItem", item)
            this.text = item && this.labelFunction
                ? this.labelFunction(item)
                : null
            this.$refs["nj-search-box--text"].select()
            this.items = []
        },
        selectFirstItem() {
            if (this.items.length != 0) {
                let _item = this.items[0]
                this.selectItem(_item)
            }
        },
        showItems() {
            this.items = this.source
        },
        navigate(event) {
            switch (event.code) {
                case "ArrowDown":
                    event.preventDefault()
                    this.nextItem()
                    break
                case "ArrowUp":
                    event.preventDefault()
                    this.previousItem()
                    break
            }
        },
        nextItem() {
            const item = document.activeElement
            if (item.nextElementSibling) {
                item.nextElementSibling.focus()
            }
        },
        previousItem() {
            const item = document.activeElement
            if (item.previousElementSibling) {
                item.previousElementSibling.focus()
            }
        },
        stopPropagation(event) {
            if (event) {
                event.stopPropagation()
            }
        },
    },
    mounted() {
        window.addEventListener("click", this.hide)
    }
}
</script>

<style scoped>
.nj-search-box {
    display: flex;
    flex-flow: column;
    gap: 0;
}

.nj-search-box-container {
    position: relative;
}

.nj-search-box-elements {
    display: flex;
    gap: 4px;
}

.nj-search-box--box--disabled {
    background-color: var(--bg-disabled)
}

.nj-search-box--label {
    display: block;
    padding: 6px 4px;
}

.nj-search-box--box {
    color: #666;
    width: 100%;
    outline: none;
    border: 1px solid #ccc;
    padding: 3px 6px;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    font-size: var(--font-size);
    border-radius: var(--radius);
    display: flex;
    align-items: center;
}

.nj-search-box--text {
    line-height: 18px;
    color: #666;
    width: 100%;
    outline: none;
    border: 1px solid #ccc;
    padding: 4px 6px;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    font-size: var(--font-size);
    border-radius: var(--radius);
    cursor: pointer;
}

.nj-search-box--text:disabled {
    background-color: var(--bg-disabled);
}

.nj-search-box--items {
    width: 100%;
    background-color: #fff;
    box-shadow: 0 4px 6px -2px #00000024;
    position: absolute;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 10;
}

.nj-search-box--item {
    border: 1px solid #ccc;
    border-top: none;
    cursor: pointer;
    padding: 8px;
}

.nj-search-box--item:focus,
.nj-search-box--item:hover {
    background-color: #eee;
    outline: none !important;
}
</style>